/* eslint-disable no-useless-escape */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    setParentCourse,
    getExamListNew,
    uploadQuestionImage,
} from "../../../Action/courseAction";
import "../../../App.css";
import AdminTable from "../../../Component/adminTable";
import CustomDropdown from "../../../Component/customDropdown";
import LabelField from "../../../Component/labelField";
import PageTitle from "../../../Module/pageTitle";
import {
    deleteQuestionOfTheDay,
    getListQuestionOftheday,
} from "../../../Action/adminPanelAction";
import DateTime from "../../../Component/dateTime";
import { getListQuizOftheday, getQuizChannelList, UpdateQuizQustion } from "../../../Action/actionFile";
import DatePicker from "../../../Component/datePicker";
import Dropdown from "../../../Component/dropdown";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import TextEditor from "../../DataEntryPanel/CreateQuestion/textEditor";
import OptionMSQ from "../../../Module/optionMSQ";
import OptionMCQ from "../../../Module/optionMCQ";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { containsMath, image_size_150, validateIsFileImageType } from "../../../Utils/validators";
import { validateIsFileImageTypeErrMsg } from "../../../Utils/errorMsg";
import AddMorebtn from "../../../Component/addMoreBtn";
import { getWordCountFromEditor } from "../../../Utils/utils";
import { showErrorSnackbar, showSuccessSnackbar } from "../../../Action/snackbarAction";

function EditQuizOfTheDay() {
    const dispatch = useDispatch();
    const [isEditMode, setIsEditMode] = useState(false);
    const [parentCourseVal, setparentCourseVal] = useState("");
    const [examName, setExamName] = useState("");
    const [topicName, setTopicName] = useState("");
    const [examList, setExamList] = useState([]);
    const [parentCourseList, setParentCourseList] = useState([]);
    const [resetParentCourse, setResetParentCourse] = useState(false);
    const [resetExam, setResetExam] = useState(false);
    const [chatID, setChatID] = useState("");
    const [resetChatID, setResetChatID] = useState(false);
    const [ChatList, setChatList] = useState([]);
    const [quizStartDate, setQuizStartDate] = useState("");
    const [duration, setDuration] = useState("");
    const [notificationDate, setNotificationDate] = useState("");
    const [quetionList, setQuetionList] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [selectedchatID, setSelectedchatID] = useState("");
    const initialValueForExam = {
        title: [],
        options: [],
        ansDescription: { text: "", img: "", video: "" },
        questionType: 1,
    };
    const [selectedquestionData, setselectedquestionData] = useState();
    const [questionData, setQuestionData] = useState();
    const [QuizList, setQuizList] = useState([]);
    const ansTypeList = [
        { _id: 1, name: "MCQ" },
        { _id: 2, name: "MSQ" },
    ]
    useEffect(() => {
        dispatch(
            getExamListNew((res) => {
                setExamList(res);
            })
        );
        dispatch(
            getQuizChannelList((res) => {
                console.log("res", res);
                setChatList(res);
            })
        );

    }, []);
    const { globalEditMode } = useSelector((state) => ({
        globalEditMode: state.courseReducer?.isEditMode,
    }));

    useEffect(() => {
        if (globalEditMode == false) {
            handleCancelEditMode();
        }
    }, [globalEditMode]);
    const changeTopic1 = (value) => {
        setTopicName(value);
        setResetTopic(false);
    };

    const handleEdit = async (value) => {
        console.log("value", value);
        setselectedquestionData(value);
        setQuizStartDate(value?.startDate);
        setQuestionData(value?.questions);
        setIsEditMode(true);
        dispatch(setParentCourse("isEditMode", true));
    };
    const handleDelete = (value) => {
        // dispatch(
        //     deleteQuestionOfTheDay(
        //         value._id,
        //         () => {
        //             const data = {
        //                 baseCourseId: parentCourseVal?._id,
        //                 examTypeId: examName?._id,
        //                 subExamTypeId: subExamName?._id,
        //                 subjectId: subject._id,
        //                 topicId: topicName._id,
        //                 complexityLevel: complexityLevel,
        //             };
        //             if (subExamName) {
        //                 data["subExamTypeId"] = subExamName._id;
        //             }
        //             dispatch(
        //                 getListQuestionOftheday(
        //                     data,
        //                     (res) => {
        //                         setQuetionList(res?.data);
        //                     },
        //                     () => { }
        //                 )
        //             );
        //         },
        //         () => { }
        //     )
        // );
    };

    const renderListMode = () => {
        return (
            <div>
                <AdminTable
                    pagename={"quizOftheDay"}
                    tableData={QuizList ? QuizList : []}
                    tableHead={[
                        "S.N",
                        "Date",
                        "Topic Name",
                        "Actions",
                    ]}
                    handleEdit={(value) => handleEdit(value)}
                    handleDelete={(value) => handleDelete(value)}
                    edit={true}
                />
            </div>
        );
    };

    const showInputMenu = (type, qIndex) => {
        setQuestionData((prev) => {
            const updated = [...prev];
            const title = updated[qIndex]?.title ? [...updated[qIndex].title] : [];
            title.push({
                descType: type,
                description: "",
            });
            updated[qIndex] = { ...updated[qIndex], title };
            return updated;
        });
    };

    const onChangeTitleImg = (e, qIndex, tIndex) => {
        e.preventDefault();
        if (!validateIsFileImageType(e)) {
            dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
            return;
        }

        if (e.target.files[0].size > image_size_150) {
            dispatch(showErrorSnackbar("File size should be less than 150 KB!!!"));
        } else {
            const file = e.target.files[0];
            dispatch(
                uploadQuestionImage(
                    file,
                    (res) => {
                        if (res?.media) {
                            dispatch(showSuccessSnackbar("File Successfully Uploaded"));
                            handleChangeTitleText(qIndex, tIndex, res.media);
                        } else {
                            dispatch(showErrorSnackbar("File Not Uploaded"));
                        }
                    },
                    () => { }
                )
            );
        }
    };
    const handleChangeTitleText = (qIndex, tIndex, value) => {
        let MaxCount = 300
        let wordCount = 0
        if (value && containsMath(value || "")) {
            // Allow larger word count for math content
        }
        else {
            wordCount = getWordCountFromEditor(value);

            if (wordCount > MaxCount) {
                dispatch(showErrorSnackbar(`Title description should be less than ${MaxCount} words.`));
                return;
            }
        }
        setQuestionData((prev) => {
            const updated = [...prev];
            if (!updated[qIndex]?.title) return prev;
            const title = [...updated[qIndex].title];
            title[tIndex] = {
                ...title[tIndex],
                description: value,
            };
            updated[qIndex] = {
                ...updated[qIndex],
                title,
            };

            return updated;
        });
    };

    const renderTitle = (qIndex) => {
        const question = questionData[qIndex];
        const MaxCount = 300;
        const handleRemoveTitleItem = (index) => {
            const newData = [...questionData];
            newData[qIndex].title.splice(index, 1);
            setQuestionData(newData);
        };
        return (
            <div className="container mt-20">
                <div className="CreateQuestionTitle d-flex justify-content-between">
                    <h5 className="admitCardHeading text-left d-flex ">Part A</h5>
                    {question?.title?.length === 0 ? (
                        <div className=" d-flex">
                            <div
                                className="cursor addInputbtn ms-2 p-1"
                                onClick={() => showInputMenu("text", qIndex)}
                            >
                                + Text
                            </div>
                            <div
                                className="cursor addInputbtn ms-2 p-1"
                                onClick={() => showInputMenu("img", qIndex)}
                            >
                                + Image
                            </div>
                        </div>
                    ) : null}
                </div>

                {question?.title?.map((item, index) => {
                    const { description } = item;
                    return (
                        <div className="position-relative col-12" key={index}>
                            <span className="position-absolute justify-content-end p-2 removeButton">
                                <HighlightOffIcon
                                    className="cursor"
                                    color="primary"
                                    fontSize="small"
                                    onClick={() => handleRemoveTitleItem(qIndex, index)}
                                />
                            </span>
                            {item?.descType === "text" ? (
                                <div className="editor_content mt-2 mb-2">
                                    <TextEditor
                                        setInputText={(value) =>
                                            handleChangeTitleText(qIndex, index, value)
                                        }
                                        value={description}
                                        isSetWordCount={containsMath(description || "") ? false : true}
                                        maxLength={MaxCount}
                                    />
                                    {description && containsMath(description || "") ? null : <div><b>Remaining Characters Count:</b> {MaxCount - (getWordCountFromEditor(description) || 0)}</div>}
                                </div>
                            ) : (
                                <div className="mt-2 mb-2">
                                    <ImagePickerAndViewer
                                        labelName={""}
                                        value={description}
                                        handleChange={(e) => onChangeTitleImg(e, qIndex, index)}
                                        htmlFor={`desc-photo-upload +${index}`}
                                        removelabel={true}
                                    />
                                </div>
                            )}
                        </div>
                    );
                })}
                {question?.title?.length > 0 ? (
                    <div className="d-flex justify-content-end">
                        <span
                            className="btn btn-outline-primary mb-3 me-2 addMorebtn"
                            onClick={() => showInputMenu("text", qIndex)}
                        >
                            + Text
                        </span>
                        <span
                            className="btn btn-outline-primary mb-3 addMorebtn"
                            onClick={() => showInputMenu("img", qIndex)}
                        >
                            + Image
                        </span>
                    </div>
                ) : null}
            </div>
        );
    };

    const renderMCQOptions = (qIndex) => {
        const question = questionData[qIndex];
        const options = question?.options || [];
        let MaxCount = 100
        let wordCount = 0
        const handleCloseOption = (optionIndex) => {
            setQuestionData((prev) => {
                const updated = [...prev];
                const updatedOptions = [...(updated[qIndex].options || [])];
                updatedOptions.splice(optionIndex, 1);
                updated[qIndex].options = updatedOptions;
                return updated;
            });
        };

        const onChangeOption = (optionIndex, data) => {
            wordCount = getWordCountFromEditor(data?.description);

            if (wordCount > MaxCount) {
                dispatch(showErrorSnackbar(`Option description should be less than ${MaxCount} words.`));
                return;
            }
            setQuestionData((prev) => {
                const updated = [...prev];
                const updatedOptions = [...(updated[qIndex].options || [])];
                if (data.isCorrect) {
                    updatedOptions.forEach((opt, i) => {
                        if (opt) opt.isCorrect = i === optionIndex;
                    });
                }
                // updatedOptions.forEach((opt, i) => {
                //     if (opt) opt.isCorrect = i === optionIndex;
                // });
                updatedOptions[optionIndex] = { ...data, isCorrect: data.isCorrect };
                updated[qIndex].options = updatedOptions;
                return updated;
            });
        };
        const onchangeMSQ = (optionIndex, data) => {
            wordCount = getWordCountFromEditor(data?.description);

            if (wordCount > MaxCount) {
                dispatch(showErrorSnackbar(`Option description should be less than ${MaxCount} words.`));
                return;
            }
            setQuestionData((prev) => {
                const updated = [...prev];
                const updatedOptions = [...(updated[qIndex].options || [])];
                updatedOptions[optionIndex] = { ...data, isCorrect: data.isCorrect };
                updated[qIndex].options = updatedOptions;
                return updated;
            });
        }
        console.log("questionData", question);
        return questionData[qIndex]?.options.map((item, index) => (
            <div className="position-relative col-auto" key={index}>
                <span className="position-absolute justify-content-end p-2 removeButton">
                    {options.length > 1 && (
                        <HighlightOffIcon
                            className="cursor"
                            color="primary"
                            fontSize="small"
                            onClick={() => handleCloseOption(index)}
                        />
                    )}
                </span>
                {question?.questionType === 1 ? (
                    <OptionMCQ
                        key={index}
                        index={index}
                        setOptionData={(data) => onChangeOption(index, data)}
                        option={item}
                        labelName={`correct${question?._id}`}
                        maxLength={MaxCount}
                        isSetWordCount={true}
                    />) : question?.questionType === 2 ? (
                        <OptionMSQ
                            key={index}
                            index={index}
                            setOptionData={(data) => onchangeMSQ(index, data)}
                            option={item}
                            maxLength={MaxCount}
                            isSetWordCount={true}
                        />) : null}
                <div><b>Remaining Characters Count:</b> {MaxCount - (getWordCountFromEditor(item?.description) || 0)}</div>
            </div>
        ));
    };

    const renderDescription = (qIndex) => {
        const desc = questionData[qIndex]?.ansDescription || {
            text: "",
            img: "",
            video: "",
        };
        const ensureAnsDescription = (prev) => {
            if (!prev[qIndex].ansDescription) {
                prev[qIndex].ansDescription = { text: "", img: "", video: "" };
            }
        };

        const updateQuestionData = (callback) => {
            setQuestionData((prev) => {
                const updated = structuredClone(prev);
                ensureAnsDescription(updated);
                callback(updated[qIndex].ansDescription);
                return [...updated];
            });
        };

        const handleRemove = (type) => {
            updateQuestionData((descObj) => {
                descObj[type] = "";
            });
        };

        const handleChangeText = (value) => {
            updateQuestionData((descObj) => {
                descObj.text = value;
            });
        };

        const handleChangeFile = (type, file) => {
            if (!file) return;
            if (
                type === "img" &&
                !validateIsFileImageType({ target: { files: [file] } })
            ) {
                dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
                return;
            }

            updateQuestionData((descObj) => {
                descObj[type] = URL.createObjectURL(file);
            });

            dispatch(
                uploadQuestionImage(
                    file,
                    (res) => {
                        if (res?.media) {
                            dispatch(showSuccessSnackbar("File Successfully Uploaded"));
                            updateQuestionData((descObj) => {
                                descObj[type] = res.media;
                            });
                        } else {
                            dispatch(showErrorSnackbar("File Not Uploaded"));
                        }
                    },
                    () => {
                        dispatch(showErrorSnackbar("Upload Failed"));
                    }
                )
            );
        };

        const showDesc = (type) => {
            updateQuestionData((descObj) => {
                if (type === "text") descObj.text = " ";
                else if (type === "img") descObj.img = " ";
                else if (type === "video") descObj.video = " ";
            });

            if (type === "img" || type === "video") {
                setTimeout(() => {
                    document
                        .getElementById(
                            type === "img"
                                ? `desc-photo-upload-${qIndex}`
                                : `desc-video-upload-${qIndex}`
                        )
                        ?.click();
                }, 100);
            }
        };

        return (
            <div className="mt-20">
                <div className="CreateQuestionTitle d-flex justify-content-between">
                    <h5 className="admitCardHeading text-left">Answer description</h5>

                    <div className="d-flex">
                        {!desc.text && (
                            <div
                                className="cursor addInputbtn ms-2 p-1"
                                onClick={() => showDesc("text")}
                            >
                                + Text
                            </div>
                        )}
                        {/* {!desc.img && (
                            <div
                                className="cursor addInputbtn ms-2 p-1"
                                onClick={() => showDesc("img")}
                            >
                                + Image
                            </div>
                        )}
                        {!desc.video && (
                            <div
                                className="cursor addInputbtn ms-2 p-1"
                                onClick={() => showDesc("video")}
                            >
                                + Video
                            </div>
                        )} */}
                    </div>
                </div>


                <div className="position-relative mb-2">
                    {/* <span className="position-absolute top-0 end-0 p-2 removeButton">
                            <HighlightOffIcon
                                className="cursor"
                                onClick={() => handleRemove("text")}
                            />
                        </span> */}
                    <TextEditor value={desc.text} setInputText={handleChangeText} isSetWordCount={true}
                        maxLength={100}
                    />
                    {desc.text && containsMath(desc.text || "") ? null : <div><b>Remaining Characters Count:</b> {100 - (getWordCountFromEditor(desc.text) || 0)}</div>}
                </div>

            </div>
        );
    };

    const onPressQuestionAdd = () => {
        setQuestionData([...questionData, initialValueForExam]);
    };
    const handleCloseQuestionData = (index) => {
        const newArray = [...questionData];
        if (index > -1) {
            newArray.splice(index, 1);
        }
        setQuestionData(newArray);
    };
    const onPressAddOption = (qIndex) => {
        setQuestionData((prev) => {
            const updated = [...prev];
            const options = updated[qIndex].options || [];

            if (options.length < 4) {
                options.push({ descType: " ", description: "", isCorrect: false });
                updated[qIndex].options = options;
            }
            return updated;
        });
    };

    const onChangeAnsType = (value, qIndex) => {
        setQuestionData((prev) => {
            const updated = [...prev];
            updated[qIndex].questionType = value?._id;
            return updated;
        });
    };
    console.log("selectedquestionData", selectedquestionData);
    const handleSubmit = async (e) => {
        e.preventDefault();
        //     const updatedQuestion = [{...questionData ,_id: selectedquestionData?._id, "questionType": selectedquestionData?.questionType,}];
        //     const updated = updatedQuestion?.map(q => ({
        //     ...q,
        //     title: q.title.map(({ _id, ...rest }) => rest),
        //     options: q.options.map(({ _id,index, ...rest }) => rest)
        // }));

        const updated = questionData?.map(q => {
            const { image, ...ansRest } = q.ansDescription || {};

            return {
                ...q,
                title: q.title.map(({ _id, ...rest }) => rest),
                options: q.options.map(({ _id, index, ...rest }) => rest),
                ansDescription: {
                    ...ansRest,
                    img: image
                }
            };
        });

        const payload = {
            channelId: selectedquestionData?.channelId,
            startDate: quizStartDate,
            // notificationDate: selectedquestionData?.notificationDate,
            duration: selectedquestionData?.duration,
            topicName: selectedquestionData?.topicName,
            questions: updated,
            quizId:selectedquestionData?.quizId
        };
        console.log("payload", payload);
        dispatch(
            UpdateQuizQustion(payload, () => {
                setselectedquestionData(null);
                setIsEditMode(false);
                dispatch(setParentCourse("isEditMode", false));
                handlegetList()
                setQuestionData(
                    {
                        title: [],
                        options: [],
                        ansDescription: { text: "", img: "", video: "" },

                    },
                );
            })
        );
    };
    console.log("quizStartDate", quizStartDate);
    const renderEditMode = () => {
        return (
            <div>
                <div className="d-flex align-items-center col-md-6">
                    <LabelField labelName={"Quiz Start Date & Time"} isRequired={true} />
                    <DateTime
                        setInputText={(value) => {
                            setQuizStartDate(value);
                        }}
                        // value={quizStartDate}
                        defaultValue={quizStartDate}
                    />
                </div>
                {questionData?.map((item, index) => {
                    const { questionType } = item;
                    const FilterAnsType = ansTypeList.find((type) => type._id === questionType);
                    return (
                        <div key={index} className=" position-relative">
                            <span className="d-flex justify-content-end p-2  ">
                                {questionData.length === 1 ? null : (
                                    <HighlightOffIcon
                                        className="cursor"
                                        color="primary"
                                        fontSize="small"
                                        onClick={() => handleCloseQuestionData(index)}
                                    />
                                )}
                            </span>

                            <div className="sectioncontainer col-md-10 p-4">
                                <div className=" d-flex w-100 row">
                                    <div className="col-auto  px-4 justify-content-between col-8">
                                        <div className="examdropdown justify-content-between">
                                            <div className="question-label">
                                                Question : {index + 1}
                                            </div>
                                        </div>
                                        <div className="d-flex mb-2 align-items-center">
                                            <LabelField labelName={"Answer Type"} />
                                            <div className="w-100">
                                                <Dropdown
                                                    setInputText={(value) => onChangeAnsType(value, index)}
                                                    value={FilterAnsType}
                                                    options={ansTypeList}
                                                    labelName="Select Answer Type"
                                                    Isrequired={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-auto  px-4 justify-content-between">
                                    <div className="d-flex"></div>
                                </div>

                                {renderTitle(index)}

                                <div className="container mb-5">{renderMCQOptions(index)}</div>

                                {questionType !== 3 &&
                                    (item.options?.length || 0) < 4 && (
                                        <div className="d-flex justify-content-end">
                                            <button
                                                type="button"
                                                className="NewOpt mb-4"
                                                onClick={() => onPressAddOption(index)}
                                            >
                                                + Add New Option
                                            </button>
                                        </div>
                                    )}

                                {renderDescription(index)}
                            </div>
                        </div>
                    );
                })}

                <div className="col-auto d-flex justify-content-end mt-4">
                    <AddMorebtn handleClick={onPressQuestionAdd} />
                </div>
                <div className="col-4 d-flex justify-content-center">
                    <button
                        type="submit"
                        className={`btn mb-3 submitbtn ${validations() ? "btn-secondary" : "btn-primary"
                            }`}
                        // className={"btn mb-3 submitbtn btn-primary"}
                        disabled={validations()}
                        onClick={handleSubmit}
                    >
                        Submit
                    </button>
                </div>
            </div>
        );
    };

    const handleCancelEditMode = () => {
        setIsEditMode(false);
        dispatch(setParentCourse("isEditMode", false));
    };
    const validations = () => {
        return (
            selectedchatID === "" ||
            startDate === ""
        );
    };
    const handlegetList = () => {
        const payload = {
            channelId: selectedchatID?._id,
            startDate: startDate,
        };
        dispatch(
            getListQuizOftheday(
                payload,
                (res) => {
                    // setQuetionList(res?.data);
                    console.log("res", res);
                    setQuizList(res?.data);
                },
                () => { }
            )
        );
    };

    const changeChatId = (value) => {
        setSelectedchatID(value);
    }
    return (
        <div className="contentBox">
            <PageTitle
                name={"EDIT QUIZ OF THE DAY"}
                isEditMode={isEditMode}
                onClick={handleCancelEditMode}
            />
            <div className="formDiv">
                <div className="col-12 formWidth">
                    {!isEditMode ? (
                        <>
                            {" "}
                            <div className="row ">
                                <div className="col-4">
                                    <div className="d-flex mb-2 align-items-center">
                                        <LabelField labelName={"Chat ID"} />
                                        <CustomDropdown
                                            setInputText={(value) => changeChatId(value)}
                                            value={selectedchatID}
                                            options={ChatList}
                                            labelName="Select Chat ID"
                                            Isrequired={true}
                                        />
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="d-flex align-items-center w-100">
                                        <LabelField labelName={"Quiz Start Date"} isRequired={true} />
                                        <DatePicker
                                            setInputText={(value) => {
                                                setStartDate(value);
                                            }}
                                            value={startDate}
                                        />
                                    </div>
                                </div>
                                {!isEditMode ? (
                                    <div className="col-4 d-flex justify-content-center">
                                        <button
                                            type="submit"
                                            className={`btn mb-3 submitbtn ${validations() ? "btn-secondary" : "btn-primary"
                                                }`}
                                            // className={"btn mb-3 submitbtn btn-primary"}
                                            disabled={validations()}
                                            onClick={handlegetList}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                            {renderListMode()}
                        </>
                    ) : (
                        <div>{renderEditMode()}</div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default EditQuizOfTheDay;
